import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RecaptchaModule } from 'ng-recaptcha';
import { environment } from '../../../environments/environment';
import { PrimeNGModule } from '../../primeng.module';
import { ToastService } from '../../services/toast/toast.service';
import { UserService } from '../../services/user/user.service';
import { BreadcrumbComponent } from '../../shared/components/breadcrumb/breadcrumb.component';
import { validPassword } from '../../shared/utils/validators';
import { UserLoginError } from '../login-customer/login-customer.component';

export class UserForgot {
  public email: string = '';
  public emailURL: string = '';
  public password: string = '';
  public passwordConfirm: string = '';
  public token: string = '';
}

@Component({
  selector: 'app-forgot',
  standalone: true,
  imports: [PrimeNGModule, BreadcrumbComponent, RecaptchaModule],
  templateUrl: './forgot.component.html',
  styleUrl: './forgot.component.scss',
})
export class ForgotComponent {
  public userError: UserLoginError = new UserLoginError();
  public userForgot: UserForgot = new UserForgot();
  public captcha = false;
  public siteKey = environment.siteKeyGoogle;

  constructor(
    private activatedRoute: ActivatedRoute,
    private toastService: ToastService,
    private userService: UserService
  ) {}

  async ngOnInit() {
    this.userForgot.email =
      this.activatedRoute.snapshot.paramMap.get('email') || '';
    this.userForgot.token =
      this.activatedRoute.snapshot.paramMap.get('token') || '';

    if (!this.userForgot.email || !this.userForgot.token) {
      this.userService.goToLogin(
        'Token inválido! Solicite novamente uma nova senha!',
        false
      );
    }
  }

  async onClickChange() {
    if (!this.validationUser()) {
      this.toastService.error('Informe sua senha e confirmação!');
      return;
    }

    if (!this.captcha) {
      this.toastService.error(
        'Faça a validação de anti-spam e tente novamente!'
      );
      return;
    }

    const msg = validPassword(
      this.userForgot.password,
      this.userForgot.passwordConfirm
    );
    if (msg) {
      this.toastService.error(msg);
      return;
    }

    try {
      await this.userService.changePassword(this.userForgot);
      this.userService.goToLogin('Sua senha foi alterada com sucesso!', true);
    } catch (error: any) {
      this.toastService.error(error);
      this.userService.goToLogin('', false);
    }
  }

  resolvedcCaptcha(captchaResponse: string | null) {
    this.captcha = captchaResponse ? true : false;
  }

  validationUser() {
    this.userError.errorPassword = !this.userForgot.password;
    this.userError.errorPasswordConfirm = !this.userForgot.passwordConfirm;
    return (
      !this.userError.errorPassword && !this.userError.errorPasswordConfirm
    );
  }
}
